import { LazyLoadImage } from "react-lazy-load-image-component";

export default function RouteSuggestionItem({ name, description, image, clickEvent }) {
    return <div 
        className="cursor-pointer bg-base-300 flex flex-row gap-2 items-center relative rounded-lg" 
        onClick={clickEvent}
    >
        {
            image &&  <LazyLoadImage className="rounded-l-lg h-full w-24 object-cover" src={image} />
        }
        <div>
            <div className="top-section w-full py-2 px-4">
            <div className="flex justify-between w-full">
                <div className="text-base-content text-md font-bold text-base-content line-clamp-2 font-titan">{ name }</div>
            </div>
            </div>
            <div className="bottom-section">
            </div>
        </div>
    </div>;
}
